import React, { useState, createRef, useEffect } from "react";
import { DialogTitle } from "../../components/ui/Dialog/CustomDialog";
import ShareIcon from "@material-ui/icons/Share";
import CancelIcon from "@material-ui/icons/Cancel";
import {
  Dialog,
  //DialogTitle,
  DialogContent,
  DialogContentText,
  FormControlLabel,
  Checkbox,
  DialogActions,
  Button,
  LinearProgress,
} from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import axios from "axios";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { useTranslation } from "react-i18next";
import { appConifg } from "../../config/default";
import { connect } from "react-redux";
import ReactGA from "react-ga";

const ShareAddressDialog = (props) => {
  const formRef = createRef();
  const [email, setEmail] = useState("");
  const [senderEmail, setSenderEmail] = useState("");
  const [isDiffUser, setIsDiffUser] = useState(false);
  const [showShareAlert, setShowShareAlert] = useState(false);
  const [alertShareType, setAlertShareType] = useState("");
  const [alertShareMsg, setAlertShareMsg] = useState("");
  const [comments, setComments] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { t, i18n } = useTranslation("ShareAddress");

  ValidatorForm.addValidationRule("isEmailMatch", () => {
    if (email == senderEmail) {
      return false;
    }
    return true;
  });

  const handleShare = () => {
    //debugger;
    setIsLoading(true);
    const data = {
      AddressPointId : props.data.AddressPointId,
      Address: props.data.Address,
      PlusCode: props.data.PlusCode,
      ThreeWordsAddress: props.data.ThreeWordsAddress,
      Latitude: props.data.Latitude.toString(),
      Longitude: props.data.Longitude.toString(),
      //  ParcelId: props.data.ParcelId,
      Makani: props.data.Makani,
      receiverEmail: email,
      senderEmail: senderEmail == "" ? email : senderEmail,
      comment: comments,
      ThreeWordsAddressAR: props.data.ThreeWordsAddressAR,
      ArabicEmailFormat: props.appSettings.language == "en" ? false : true,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + props.token.access_token,
    };
    axios
      .post(appConifg.Address.AddressApiUrl + "/ShareAddress/Share", data, {
        headers: headers,
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.isSucceeded) {
          props.onClose();
          props.onSuccess("Address shared successfully!");
          setIsLoading(false);
          ReactGA.event({
            category: "ShareAddress",
            action: "Address shared",
          });
        } else {
          setAlertShareMsg(response.data.status.message);
          setAlertShareType("error");
          setShowShareAlert(true);
          setIsLoading(false);
        }
      })
      .catch((ex) => {
        setAlertShareMsg("Connection error, please try again!");
        setAlertShareType("error");
        setShowShareAlert(true);
        setIsLoading(false);
      });
  };
  const handleCheckBox = (e) => {
    setIsDiffUser(!isDiffUser);
  };
  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  return (
    <Dialog
      className="customeBorder"
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="form-dialog-title"
      disableBackdropClick={true}
    >
      {/* <DialogTitle id="form-dialog-title">
                {t("DialogTitle")}
                </DialogTitle> */}
      <DialogTitle onClose={props.onClose} disabled={isLoading}>
        {t("DialogTitle")}
      </DialogTitle>
      <ValidatorForm ref={formRef} onSubmit={handleShare}>
        <DialogContent>
          <DialogContentText>{t("shareAddressInfo")}</DialogContentText>

          <TextValidator
            autoFocus
            required
            margin="dense"
            id="emailAddress"
            label={t("EmailAddress")}
            type="email"
            value={email}
            onChange={onChangeEmail}
            fullWidth
            validators={["required", "isEmail"]}
            errorMessages={[t("errorRequired"), t("errorEmailValid")]}
          />
          <TextValidator
            id="outlined-multiline-static"
            label={t("Comments")}
            required
            margin="dense"
            multiline
            rows={5}
            value={comments}
            validators={["required"]}
            errorMessages={[t("errorRequired")]}
            onChange={(e) => setComments(e.target.value)}
            fullWidth
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={isDiffUser}
                onChange={handleCheckBox}
                color="primary"
              />
            }
            label={t("ShareWithDifferentuser")}
          />
          {isDiffUser ? (
            <>
              <TextValidator
                autoFocus
                required
                margin="dense"
                id="senderEmail"
                label={t("SenderEmail")}
                type="email"
                value={senderEmail}
                onChange={(e) => setSenderEmail(e.target.value)}
                fullWidth
                validators={["required", "isEmail", "isEmailMatch"]}
                errorMessages={[
                  t("errorRequired"),
                  t("errorEmailValid"),
                  t("errorEmailMatch"),
                ]}
              />
            </>
          ) : (
            ""
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={props.onClose}
            color="secondary"
            disabled={isLoading}
            variant="outlined"
            startIcon={<CancelIcon />}
          >
            {t("Cancel")}
          </Button>
          <Button
            type="submit"
            color="primary"
            disabled={isLoading}
            variant="outlined"
            startIcon={<ShareIcon />}
          >
            {t("Share")}
          </Button>
        </DialogActions>
        {isLoading ? <LinearProgress /> : ""}
      </ValidatorForm>
      {showShareAlert ? (
        <Alert severity={alertShareType}>
          <AlertTitle>
            {alertShareType == "success" ? "Success" : "Error"}
          </AlertTitle>
          {alertShareMsg}
        </Alert>
      ) : (
        ""
      )}
    </Dialog>
  );
};
const mapStateToProps = (state) => {
  return {
    appSettings: state.settings,
  };
};
export default connect(mapStateToProps, null)(ShareAddressDialog);
